<template>
  <div>
    <vue-good-table
      :line-numbers="true"
      :columns="columns"
      :rows="rows"
      :total-rows="total"
      :sort-options="{ enabled: true }"
      :pagination-options="{ enabled: true }"
      style-class="vgt-table border-0 table-auto"
      @on-sort-change="$emit('sort-change', $event)"
      @on-page-change="$emit('page-change', $event)"
      @on-per-page-change="$emit('per-page-change', $event)"
    >
      <div slot="emptystate" class="text-center font-size-14">No data available</div>

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'action'" class="d-flex gap-3 justify-content-center align-items-center">
          <b-button class="no-wrap btn-pill" variant="warning" size="sm" title="Update" @click="$emit('update', props.row)">
            <span class="fe fe-edit"></span>
          </b-button>
        </span>

        <span v-else-if="props.column.field === 'is_active'">
          <div class="d-flex flex-row align-items-center justify-content-start" @click="$emit('change-status', props.row)">
            <b-form-checkbox switch v-model="props.row.is_active" class="m-0 custom-switch" :disabled="true">
              <span :class="['badge ms-2', props.row.is_active ? 'badge-success' : 'badge-secondary']">
                {{ props.row.is_active ? "Active" : "Inactive" }}
              </span>
            </b-form-checkbox>
          </div>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between align-items-center mt-3 px-3">
          <div class="text-muted">
            Showing
            <strong>{{ showingFrom }} - {{ showingTo }}</strong>
            of <strong>{{ total }}</strong> items
          </div>

          <b-pagination
            v-model="page"
            :total-rows="total"
            :per-page="pageSize"
            first-number
            last-number
            align="right"
            size="md"
            @change="$emit('page-change-from-bv', $event)"
          />
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { props } from "vue2-dropzone";

export default {
  name: "NotificationTemplateTable",
  props: {
    rows: Array,
    total: Number,
    showingFrom: Number,
    showingTo: Number,
    page: Number,
    pageSize: Number,
  },

  data() {
    return {
      columns: [
        {
          label: "Name",
          field: "name",
          sortable: true,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Tenant",
          field: "tenant",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Module",
          field: "module_type_name",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Status",
          field: "is_active",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold w-action",
          tdClass: "color-secondary text-center",
        },
      ],
    };
  },
};
</script>

<style scoped>
.w-action {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
}

.vgt-table.table-auto table {
  table-layout: auto !important;
}

:deep(.custom-switch .custom-control-label) {
  display: flex !important;
  align-items: center !important;
  cursor: pointer;
}

:deep(.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label::before) {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
}

:deep(.custom-switch .custom-control-input:checked ~ .custom-control-label::before) {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

:deep(.custom-switch .custom-control-input:checked ~ .custom-control-label::after) {
  background-color: #fff !important;
}

:deep(.table-header) {
  font-size: 12px !important;
}

:deep(.vgt-table td, .vgt-table th) {
  font-size: 12px !important;
}
</style>
